import React from "react";
import { Select as SelectMui, MenuItem, FormControl, InputLabel, useTheme } from "@mui/material";

const SelectInput = ({ id, label, options, selected, fullWidth = true, onChange, ml = 0, mr = 0, mt = 0, disabled = false }) => {

    const theme = useTheme();
    const labelId = `label-select-${id}`;

    // flag that indicates if the selected value is in the options array
    const isInOpt = Boolean(options.find((item) => item.id === selected));

    const handleChange = (event) => {
        onChange(event.target.value);
    }

    return (
        <FormControl variant="outlined" fullWidth={fullWidth} sx={{ marginLeft: theme.spacing(ml), marginRight: theme.spacing(mr), marginTop: theme.spacing(mt) }}>
            <InputLabel size="small" id={labelId}>{label}</InputLabel>
            <SelectMui
                size="small"
                id={id}
                name={id}
                value={isInOpt ? (selected ?? "") : ""}
                onChange={handleChange}
                labelId={labelId}
                label={label}
                disabled={disabled}
                sx={{
                    borderRadius: theme.spacing(1),
                    fontWeight: "bold",
                    backgroundColor: theme.palette.background.paper,
                }}
            >
                {
                    options.map((item) => {
                        return <MenuItem key={`opt-${item.id}`} value={item.id}>{item.label}</MenuItem>
                    })
                }
            </SelectMui>
        </FormControl>
    );
}

export default SelectInput;
